<template>
  <div class="v_all_all">
    <div class="v_all_background" v-if="haveData == 1">
      <!-- <el-input v-model="b"></el-input>
      <el-input v-model="c"></el-input>
      <el-input v-model="d"></el-input> -->
      <div class="v_top_line"></div>
      <div class="v_space">
        <div class="v_space_title">
          <div class="v_space_left">纪念堂名称：</div>
          <div class="v_space_name">
            {{ spaceDetailData.name }}
          </div>
        </div>
        <div class="v_space_title">
          纪念堂编号：<span class="v_space_name">{{
            spaceDetailData.codeNew
          }}</span>
        </div>
        <div class="v_space_title">
          创建日期：<span class="v_space_name_black">{{
            spaceDetailData.createTimeNew
          }}</span>
        </div>
        <div class="v_space_title">
          有效期至：<span class="v_space_name_black">{{
            spaceDetailData.foreverState == 1
              ? "永久"
              : spaceDetailData.closeTimeNew
          }}</span>
        </div>
        <div class="v_space_title">
          纪念堂状态：<span class="v_space_name_black">{{
            spaceDetailData.stateNew
          }}</span><span class="v_space_name_black_red" v-if="spaceDetailData.spaceFrozen == 1">{{
              spaceDetailData.stateCold }}</span>
        </div>
        <div class="v_space_title">
          <div class="v_space_left">经手：</div>
          <div class="v_space_name_black">
            {{ spaceDetailData.unitShortNames }}
          </div>
        </div>
        <div class="v_space_title" style="margin-bottom: 0rem">
          纪念堂访问量：<span class="v_space_name_black">{{
            spaceDetailData.viewCount
          }}</span>
        </div>
        <div class="v_space_line"></div>
      </div>
      <div class="v_top_line"></div>
      <div class="v_space_person_list">
        <div class="v_space_person_title">
          此纪念堂管理员<span class="v_space_person_number">（合计: {{ list.length }}）</span>
        </div>
        <div class="v_line"></div>
        <div v-if="list.length == 0" class="v_have_no">
          <img src="@/assets/images/personal/iv_have_no.png" alt="" class="iv_have_no" />
          <div class="v_have_no_text">当前暂无纪念堂管理员</div>
        </div>
        <div v-for="(item, i) in list" :key="i" class="v_space_person_item">
          <div class="v_space_person_item_top">
            <img :src="item.photo" alt="" class="iv_space_person_item_img" />
            <div style="margin-left: 1rem">
              <div class="v_space_person_item_name">{{ item.nickname }}</div>
              <div class="v_space_person_item_title">
                是此纪念堂的：<span class="v_space_person_item_result">{{
                  item.userState == 1 ? "主办人" : "管理员"
                }}</span>
              </div>
              <div class="v_space_person_item_title">
                拜访此纪念堂的次数：<span class="v_space_person_item_result">{{
                  item.viewCount
                }}</span>
              </div>
              <div class="v_space_person_item_title">
                <div class="v_space_person_item_result_left">客服：</div>
                <div class="v_space_person_item_result">
                  {{ item.serviceAdminName }}
                </div>
              </div>
              <div class="v_space_person_item_title">
                是否添加好友：<span class="v_space_person_item_result">{{
                  item.serviceAdminFriend == 1 ? "是" : "—"
                }}</span>
              </div>
            </div>
          </div>
          <div class="v_space_person_item_line_another" v-if="item.serviceAdminFriend == 0"></div>
          <div class="v_space_person_item_line" v-if="item.serviceAdminFriend == 1"></div>
          <div class="v_space_person_item_bottom" v-if="item.serviceAdminFriend == 1">
            <div class="v_space_person_item_button" v-if="item.canSend" @click="toSendMessage(item.openid)">
              发消息
            </div>
            <div class="v_space_person_item_button_blue" v-if="!item.canSend" @click="sendMessageToA(item)">
              消息转推
            </div>
          </div>
        </div>
        <div class="v_bottom_line"></div>
      </div>
    </div>
    <div v-if="haveData == 2" class="v_have_no_data">
      <img src="@/assets/images/personal/iv_have_no.png" alt="" class="iv_no_data" />
      <div class="v_no_data_text">纪念堂已失效</div>
    </div>
    <el-dialog class="dialog-month-add" title="延长有效期" :visible.sync="dialogVisible" width="80%" :show-close="false"
      :close-on-click-modal="false">
      <div style="display: flex;flex-direction: column;">
        <span>请选择延长几个月：</span>
        <el-select v-model="monthNum" placeholder="请选择">
          <el-option v-for="item in 12" :key="item" :label="item + '个月'" :value="item">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addCloseTime">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
import { updataLink, nowDate, PMSLIST } from "@/utils/utils";
import axios from "axios";
export default {
  data() {
    return {
      // b: "",
      // c: "",
      // d: "",

      code: "",
      linkUrl: "",
      spaceId: "",
      url: "",
      loginData: {},
      spaceDetailData: {},
      list: [],
      userId: "",
      loadingAll: "",
      haveData: 0,
      dialogVisible: false,
      monthNum: 1,
    };
  },
  created() {
    if (this.$route.query.img != null && this.$route.query.img != undefined) {
      let link = document.createElement("a");
      let name = "";
      if (this.$route.query.name == "a") {
        //新建
        name = "新建纪念堂";
      } else {
        //续费
        name = "续费-";
        if (this.$route.query.name.length > 6) {
          name = name + this.$route.query.name.substring(0, 6);
        } else {
          name = name + this.$route.query.name;
        }
      }
      axios({
        method: "POST",
        url: "/api/common/getUrlDataSource",
        data: {
          data: this.$route.query.img,
        },
        responseType: "blob",
      }).then((response) => {
        link.href = URL.createObjectURL(response.data);
        name = name + nowDate.getNowDate() + ".png";
        console.log(name);
        link.download = name;
        document.body.appendChild(link);
        link.click();
      });
      return;
    }
    this.loadingAll = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    let link = window.location.href;
    let linkk = window.location.href;
    let linkUrl = linkk.split("#/wxspacedetails");
    this.linkUrl = linkUrl[0];

    let links = link.split("code=");
    let linksA = links[1].split("&state=");
    this.code = linksA[0];
    let linksB = linksA[1].split("#/wxspacedetails");
    this.getLoginWxEnterprise(linksB);
  },
  computed: {},

  mounted() { },

  methods: {
    //SpringSecurity企微登录
    getLoginWxEnterprise(linksB) {
      let that = this;
      let postData = new FormData();
      postData.append("code", this.code);
      let testRequest = new Request(this.url + "/loginWxEnterprise", {
        method: "POST",
        body: postData,
      });
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          //this.c = JSON.stringify(res);
          if (res.status == 1000) {
            this.loginData = res.data;
            if (linksB[0] != "") {
              this.spaceId = linksB[0];
              this.findWxEnterpriseById();
            } else if (res.status == 1004) {
              that.loadingAll.close();
              that.$message.error("当前登录账户已禁用");
            } else if (res.status == 1027) {
              that.loadingAll.close();
              that.$message.error("您的权限已发生变更，如有问题请联系中枢");
              this.getLoginWxEnterprise(linksB);
            }
          } else {
            that.loadingAll.close();
            that.$message.error("获取信息失败，请检查网络连接");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //获取空间详情-企微
    findWxEnterpriseById() {
      let that = this;
      let testRequest = new Request(
        this.url + "/bygDeadManV2/findWxEnterpriseById",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: this.spaceId,
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          //that.b = JSON.stringify(res);
          if (res.status == 1000) {
            that.haveData = 1;
            var arr = res.data.code.split("");
            var arrs = [];
            var str = "";
            while (arr.length > 0) {
              var arrThis = arr.splice(0, 4);
              var strThis = arrThis.join("");
              arrs.push(strThis);
            }
            str = arrs.join(" ");
            res.data.codeNew = str;
            res.data.createTimeNew =
              res.data.createTime.substring(0, 4) +
              "/" +
              res.data.createTime.substring(5, 7) +
              "/" +
              res.data.createTime.substring(8, 10);
            res.data.closeTimeNew =
              res.data.closeTime.substring(0, 4) +
              "/" +
              res.data.closeTime.substring(5, 7) +
              "/" +
              res.data.closeTime.substring(8, 10);

            if (res.data.foreverState == 1) {
              res.data.stateNew = "永久";
            } else {
              if (res.data.status == 2) {
                res.data.stateNew = "过期";
              } else if (res.data.status == 1) {
                if (res.data.closeTimeState == 1) {
                  res.data.stateNew = "即将到期";
                } else {
                  res.data.stateNew = "有效";
                }
              }
            }
            if (res.data.spaceFrozen == 1) {
              res.data.stateCold = "冻结";
            }
            this.spaceDetailData = res.data;
            this.findWxEnterpriseUserDmRelationById();
          } else if (res.status == 1076) {
            that.haveData = 2;
            that.loadingAll.close();
          } else {
            that.loadingAll.close();
            that.$message.error("获取信息失败，请检查网络连接");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //获取空间详情-成员列表-企微
    findWxEnterpriseUserDmRelationById() {
      let that = this;
      let testRequest = new Request(
        this.url + "/bygDeadManV2/findWxEnterpriseUserDmRelationById",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: this.spaceId,
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          that.loadingAll.close();
          //that.c = JSON.stringify(res);
          if (res.status == 1000) {
            res.data.forEach((item) => {
              if (
                item.serviceEnterpriseNumber == that.loginData.enterpriseNumber
              ) {
                item.canSend = true;
              } else {
                item.canSend = false;
              }
            });
            this.list = res.data;
          } else {
            that.$message.error("获取信息失败，请检查网络连接");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    toSendMessage(userId) {
      this.userId = userId;
      this.getWxEnterpriseAgentJSResDto();
    },

    sendMessageToA(item) {
      let that = this;
      let params = {
        dmId: this.spaceId,
        name: this.spaceDetailData.name,
        code: this.spaceDetailData.code,
        closeTime: this.spaceDetailData.closeTime,
        nickname: item.nickname,
        tel: item.tel,
        adminEnterpriseNumber: item.serviceEnterpriseNumber,
      };
      let testRequest = new Request(
        this.url + "/bygDeadManV2/sendMessageByCloseTimeForward",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: params,
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            this.d = "发送成功";
            that.$message.success("操作成功");
          } else {
            that.$message.error("获取信息失败，请检查网络连接");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //到期日增加-企微
    addCloseTime() {
      if (!this.dialogVisible) {
        this.dialogVisible = true;
        return;
      }
      let that = this;
      let testRequest = new Request(
        this.url + "/bygDeadManV2/addCloseTime",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: {
              dmId: this.spaceId,
              monthNum: this.monthNum,
            },
          }),
        }
      );
      fetch(testRequest).then((response) => {
        return response.json();
      }).then((res) => {
        //that.c = JSON.stringify(res);
        if (res.status == 1000) {
          that.$message.success("操作成功");
          this.dialogVisible = false;
        } else {
          that.$message.error("获取信息失败，请检查网络连接");
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    //获取企业微信应用JS授权信息
    getWxEnterpriseAgentJSResDto() {
      let that = this;
      let testRequest = new Request(
        this.url + "/common/getWxEnterpriseAgentJSResDto",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: this.linkUrl,
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            this.toWxAgent(res.data);
          } else {
            that.$message.error("获取信息失败，请检查网络连接");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    toWxAgent(data) {
      let that = this;
      wx.agentConfig({
        corpid: data.appId, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: data.agentId, // 必填，企业微信的应用id （e.g. 1000247）
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
        jsApiList: [
          "openUserProfile",
          "getCurExternalContact",
          "downloadImage",
          "previewImage",
        ], //必填，传入需要使用的接口名称
        success: function (res) {
          // 回调
          that.toProfile();
        },
        fail: function (res) {
          if (res.errMsg.indexOf("function not exist") > -1) {
            alert("版本过低请升级");
            return;
          }
          that.$message.error("获取信息失败，请检查网络连接");
          //that.loadingAll.close();
        },
      });
    },

    toProfile() {
      let that = this;
      wx.invoke(
        "openUserProfile",
        {
          type: 2, //1表示该userid是企业成员，2表示该userid是外部联系人
          userid: that.userId, //可以是企业成员，也可以是外部联系人
        },
        function (res) {
          //that.d = JSON.stringify(res);
          if (res.err_msg != "openUserProfile:ok") {
            //错误处理
            that.$message.error("获取信息失败，请检查网络连接");
          }
        }
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.v_all_all {
  background-color: #F7F8F9;
}

.v_all_background {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: #ffffff;

  &::-webkit-scrollbar {
    display: none;
  }
}

.v_top_line {
  width: 100%;
  height: 10px;
  background: #F7F8F9;
}

.v_space {
  background-color: #ffffff;
  padding-top: 15px;

  .v_space_title {
    margin-left: 18px;
    font-size: 16px;
    font-weight: 400;
    color: #949494;
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;
  }

  .v_space_left {
    flex-shrink: 0;
  }

  .v_space_name {
    font-size: 16px;
    font-weight: 400;
    color: #F19100;
    margin-right: 12px;
    word-wrap: break-word;
    word-break: break-all;
  }

  .v_space_name_black {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    margin-right: 10px;
  }

  .v_space_name_black_red {
    font-size: 16px;
    font-weight: 400;
    color: #EC2F2F;
    margin-right: 10px;
  }
}

.v_space_line {
  height: 15px;
}

.v_space_person_list {
  background-color: #ffffff;

  .v_space_person_title {
    margin-left: 18px;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }

  .v_space_person_number {
    height: 60px;
    line-height: 60px;
    font-size: 15px;
    font-weight: 400;
    color: #949494;
    margin-left: -5px;
  }
}

.v_line {
  background: #D5D5D5;
  height: 1px;
  width: 100%;
}

.v_space_person_item {
  background: #F7F8F9;
  margin-left: 18px;
  margin-right: 18px;
  padding-top: 15px;
  margin-top: 15px;
  width: auto;

  .v_space_person_item_top {
    margin-bottom: 15px;
    margin-left: 18px;
    display: flex;
    flex-direction: row;
  }

  .iv_space_person_item_img {
    width: 45px;
    height: 45px;
    border-radius: 5px;
    flex-shrink: 0;
  }

  .v_space_person_item_name {
    font-size: 25px;
    font-weight: 500;
    color: #000000;
    word-wrap: break-word;
    word-break: break-all;
    margin-right: 10px;
  }

  .v_space_person_item_title {
    margin-top: 5px;
    font-size: 13px;
    font-weight: 400;
    color: #949494;
    display: flex;
    flex-direction: row;
  }

  .v_space_person_item_result {
    font-size: 13px;
    font-weight: 400;
    color: #000000;
    word-wrap: break-word;
    word-break: break-all;
    margin-right: 10px;
  }

  .v_space_person_item_result_left {
    flex-shrink: 0;
  }
}

.v_space_person_item_line {
  margin-left: 15px;
  margin-right: 15px;
  width: auto;
  height: 1px;
  border-bottom: 1px dashed #949494;
}

.v_space_person_item_line_another {
  width: auto;
  height: 1px;
}

.v_space_person_item_bottom {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.v_space_person_item_button {
  width: 150px;
  height: 30px;
  background: linear-gradient(90deg, #FF9B5D 0%, #FFBB00 100%);
  box-shadow: 0px 8px 20px 1px #FFDDC3;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 30px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 15px;
}

.v_space_person_item_button_blue {
  width: 150px;
  height: 30px;
  background: linear-gradient(90deg, #418EEF 0%, #70CDFF 100%);
  box-shadow: 0px 8px 20px 1px #DFF3FE;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 30px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 15px;
}

.v_bottom_line {
  height: 10px;
}

.v_have_no {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 206px;

  .iv_have_no {
    width: 125px;
    height: 125px;
  }

  .v_have_no_text {
    margin-top: 20px;
    font-size: 15px;
    font-weight: 400;
    color: #949494;
  }
}

.v_have_no_data {
  position: fixed;
  left: 0;
  right: 0;
  top: 10px;
  bottom: 0;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  // justify-content: center;
  .iv_no_data {
    margin-top: 20vh;
    width: 125px;
    height: 125px;
    margin-bottom: 50px;
  }

  .v_no_data_text {
    font-size: 15px;
    font-weight: 400;
    color: #949494;
  }
}
.dialog-month-add >>> .el-dialog__body{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/WxSpaceDetails/WxSpaceDetails.vue